import React, { FC } from 'react';
import { Link } from 'components/Link';
import { Control, Language, Service } from '@yleisradio/areena-types';
import { useIcon } from 'components/Controls/Control/useIcon';
import styles from './TextLinkControl.module.scss';
import { useControl } from 'components/Controls/Control/useControl';
import {
  isActivator,
  isNavigator,
} from 'components/Controls/Control/typeGuards';
import { getCanonicalBaseURL } from 'utils/url';
import { serviceRoutes } from 'utils/routes';
import { useUILanguage } from 'hooks/useUILanguage';
import { useAreenaService } from 'contexts/AreenaServiceContext';
import { FunctionalityId } from 'utils/control';

type Props = { control: Control; onClick(): void };

const TextLinkControl: FC<Props> = ({ control: controlProp, onClick }) => {
  const Icon = useIcon(controlProp);
  const { control } = useControl({
    control: controlProp,
  });

  const language = useUILanguage();
  const { areenaService } = useAreenaService();

  const otherLanguageUrl = (
    language: Language,
    service: Service | undefined
  ) => {
    const targetLanguage: Language = language === 'fi' ? 'sv' : 'fi';
    const targetBaseUrl = getCanonicalBaseURL(targetLanguage);

    if (!service) {
      return targetBaseUrl;
    }
    return `${targetBaseUrl}/${serviceRoutes[service][targetLanguage]}`;
  };

  return (
    <>
      {isNavigator(control) && control.destination && (
        <Link
          pointer={control.destination}
          className={styles.link}
          onClick={onClick}
        >
          {Icon && <Icon className={styles.icon} aria-hidden />}
          <span className={styles.text}>{control.title}</span>
        </Link>
      )}
      {isActivator(control) &&
        control.functionality.id === FunctionalityId.SwitchLanguage && (
          <Link
            className={styles.link}
            pointer={{
              uri: `${otherLanguageUrl(language, areenaService)}`,
            }}
          >
            {Icon && <Icon className={styles.icon} aria-hidden />}
            <span className={styles.text}>{control.title}</span>
          </Link>
        )}
    </>
  );
};

export { TextLinkControl };
